module.exports = __webpack_public_path__ + "img/diamonds.24b0b40.jpg";